// src/pages/Login.tsx

/** @jsx createElement */
import { createElement } from "@mitosis/frontend-base";
import { RequestCodeForm } from "@mitosis/frontend-base/auth";

document.addEventListener("DOMContentLoaded", () => {
  try {
    document.body.appendChild(<main>{RequestCodeForm()}</main>);
  } catch (error) {
    console.error("Failed to initialize page:", error);
  }
});
